<template>
  <div class="historiesStaff">
    <!-- :setready="ready"
    :setmyjob="myjobs"
    :setpacking="packing"
    :orders="newjobs" -->
    <navbarStaff/>
  <div class="space"></div>
  <div class="container">
    <div class="tebs_content">
      <div class="tebs_floting">
        <div class="row">
          <div class="col-5">
            <div class="circle_content">
              <div class="circle_floting">
                <div class="circle">
                  <span class="circle__btn">
                    <img
                      class="circle_img"
                      :src="require('@/assets/avatars/' + code + '.jpg')"
                      alt=""
                    />
                    <!-- <ion-icon class="pause" name="pause"></ion-icon>
                        <ion-icon class="play" name="play"></ion-icon> -->
                  </span>
                  <span class="circle__back-1"></span>
                  <span class="circle__back-2"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-7">
            <br />
            <div class="segmented-control">
              <input
                type="radio"
                name="radio2"
                v-model="radio_btn"
                @change="onChange"
                value=""
                id="tab-1"
                checked
              />
              <label for="tab-1" class="segmented-control__1">
                <p>All order</p></label
              >
              <input
                type="radio"
                name="radio2"
                v-model="radio_btn"
                @change="onChange"
                value="orders"
                id="tab-2"
              />
              <label for="tab-2" class="segmented-control__2">
                <p>Order's</p>
              </label>

              <input
                type="radio"
                name="radio2"
                v-model="radio_btn"
                @change="onChange"
                value="locker"
                id="tab-3"
              />
              <label for="tab-3" class="segmented-control__3">
                <p>Locker</p>
              </label>

              <div class="segmented-control__color"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="space"></div>
    <br />
    <!-- ======================================== Detail Tabs ============================================= -->
    <!-- ======================================== All Order=================================================== -->
    <div class="all-order" v-if="radio_btn === ''">
      <div class="card-columns">
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="6">

              </b-col>
              <b-col cols="6">
                <div class="search">
                  <input
                    id="myInput"
                    type="text"
                    class="search__input" 
                    placeholder="Search.."
                    style="border-radius: 30px"
                    pull-right
                  />
                  <div class="search__icon">
                    <i class="fa-solid fa-search"></i>
                    <!-- <ion-icon name="search"></ion-icon> -->
                  </div>
                </div>
              </b-col>
            </b-row>
            <br />
            <div class="card card-order-list calendar-border">
              <div class="card-body">
                <b-table
                  striped
                  hover
                  :items="items"
                  :fields="fieldsAll"
                  responsive="sm"
                  :per-page="perPageAll"
                  :current-page="currentPageAll"
                  @row-clicked="toggleDetails"
                  id="my-table"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(mustbeget_date)="data">
                    {{ data.item.mustbeget_date | moment }}
                  </template>
                  <template #row-details="row">
                    <div
                     
                      class="container"
                    >
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">ลำดับ</th>
                            <th scope="col">ชื่อหนังสือ</th>
                            <th scope="col">ชื่อผู้แต่ง</th>
                            <th scope="col">บาร์โค้ด</th>
                            <th scope="col">ที่อยู่หนังสือ</th>
                            <th scope="col">หมวดหมู่</th>
                            <th scope="col">สถานะ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr  v-for="(proc, index) in row.item.order_detail"
                      :key="index">
                            <th scope="row">{{ index + 1 }}</th>
                            <td>{{ proc.book_title }}</td>
                            <td>
                              <div
                                v-if="
                                  proc.book_author == '' ||
                                  proc.book_author === null
                                "
                              >
                                ไม่ทราบชื่อผู้แต่ง
                              </div>
                              {{ proc.book_author }}
                            </td>

                            <td>{{ proc.barcode }}</td>
                            <td>{{ proc.book_location }}</td>
                            <td>{{ proc.book_cassification }}</td>
                            <td>{{ proc.trans_status }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>
                </b-table>
                <div class="pagination-div">
                  <b-pagination
                    v-model="currentPageAll"
                    :total-rows="rows"
                    :per-page="perPageAll"
                    aria-controls="my-table"
                    pills
                    align="right"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
       

        <!-- <div class="col-lg-12 col-md-12 col-xs-12">
          <div class="row">
            <div class="col-lg-8 col-md-8 col-xs-8"></div>
            <div class="col-lg-4 col-md-4 col-xs-4">
             
            </div>
          </div>
          
          <div class="card card-order-list calendar-border">
            <div class="card-body">
              <b-table
                striped
                hover
                :items="items"
                :fields="fieldsAll"
                responsive="sm"
                :per-page="perPageAll"
                :current-page="currentPageAll"
                @row-clicked="toggleDetails"
                id="my-table"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mustbeget_date)="data">
                  {{ data.item.mustbeget_date | moment }}
                </template>
                <template #row-details="row">
                  <div
                    v-for="(proc, index) in row.item.order_detail"
                    :key="index"
                    class="container"
                  >
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">ชื่อหนังสือ</th>
                          <th scope="col">ชื่อผู้แต่ง</th>
                          <th scope="col">บาร์โค้ด</th>
                          <th scope="col">ที่อยู่หนังสือ</th>
                          <th scope="col">หมวดหมู่</th>
                          <th scope="col">สถานะ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">{{ index + 1 }}</th>
                          <td>{{ proc.book_title }}</td>
                          <td>
                            <div
                              v-if="
                                proc.book_author == '' ||
                                proc.book_author === null
                              "
                            >
                              ไม่ทราบชื่อผู้แต่ง
                            </div>
                            {{ proc.book_author }}
                          </td>

                          <td>{{ proc.barcode }}</td>
                          <td>{{ proc.book_location }}</td>
                          <td>{{ proc.book_cassification }}</td>
                          <td>{{ proc.trans_status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </b-table>
              <div class="pagination-div">
                <b-pagination
                  v-model="currentPageAll"
                  :total-rows="rows"
                  :per-page="perPageAll"
                  aria-controls="my-table"
                  pills
                  align="right"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- END -->
    <!-- ======================================== Order's=================================================== -->
    <div class="orders" v-if="radio_btn === 'orders'">
      <br />
      <div class="card-columns">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="card card-order-list calendar-border">
              <div class="card-body">
                <b-table
                  striped
                  hover
                  :items="myorders"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPageOrder"
                  :current-page="currentPageOrder"
                  @row-clicked="toggleDetails"
                  id="my-order"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(mustbeget_date)="data">
                    {{ data.item.mustbeget_date | moment }}
                  </template>
                  <template #row-details="row">
                    <div
                     
                      class="container"
                    >
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">ลำดับ</th>
                            <th scope="col">ชื่อหนังสือ</th>
                            <th scope="col">ชื่อผู้แต่ง</th>
                            <th scope="col">บาร์โค้ด</th>
                            <th scope="col">ที่อยู่หนังสือ</th>
                            <th scope="col">หมวดหมู่</th>
                            <th scope="col">สถานะ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr  v-for="(proc, index) in row.item.order_detail"
                      :key="index">
                            <th scope="row">{{ index + 1 }}</th>
                            <td>{{ proc.book_title }}</td>
                            <td>
                              <div
                                v-if="
                                  proc.book_author == '' ||
                                  proc.book_author === null
                                "
                              >
                                ไม่ทราบชื่อผู้แต่ง
                              </div>
                              {{ proc.book_author }}
                            </td>

                            <td>{{ proc.barcode }}</td>
                            <td>{{ proc.book_location }}</td>
                            <td>{{ proc.book_cassification }}</td>
                            <td>{{ proc.trans_status }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>

                 
                </b-table>
                <div class="pagination-div">
                  <b-pagination
                    v-model="currentPageOrder"
                    :total-rows="rowsorder"
                    :per-page="perPageOrder"
                    aria-controls="my-order"
                    pills
                    align="right"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END -->
    <!-- ======================================== Locker=================================================== -->
    <div class="locker" v-if="radio_btn === 'locker'">
      <br/>
      <div class="card-columns">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="card card-order-list calendar-border">
              <div class="card-body">
                <!-- sticky-header -->
                <b-table
                responsive="sm"
                flex
                style="width: 100%; max-height: 70vh;"
                striped
                hover
                :items="onlocker"
                :fields="fieldsOnlock"
                :current-page="currentPageLock"
                :per-page="perPageLock"
               
                @row-clicked="toggleDetails"
                id="my-locker"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mustbeget_date)="data">
                  {{ data.item.mustbeget_date | moment }}
                </template>
                <template #row-details="row">
                  <div
                  
                    class="container"
                  >
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">ลำดับ</th>
                          <th scope="col">ชื่อหนังสือ</th>
                          <th scope="col">ชื่อผู้แต่ง</th>
                          <th scope="col">บาร์โค้ด</th>
                          <th scope="col">ที่อยู่หนังสือ</th>
                          <th scope="col">หมวดหมู่</th>
                          <th scope="col">สถานะ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr   v-for="(proc, index) in row.item.order_detail"
                    :key="index">
                          <th scope="row">{{ index + 1 }}</th>
                          <td>{{ proc.book_title }}</td>
                          <td>
                            <div
                              v-if="
                                proc.book_author == '' || proc.book_author === null
                              "
                            >
                              ไม่ทราบชื่อผู้แต่ง
                            </div>
                            {{ proc.book_author }}
                          </td>
    
                          <td>{{ proc.barcode }}</td>
                          <td>{{ proc.book_location }}</td>
                          <td>{{ proc.book_cassification }}</td>
                          <td>{{ proc.trans_status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END -->
  </div>
  </div>
</template>

<script>
import navbarStaff from '../layouts/navbar_staff.vue';
import axios from "axios";
// import { VueGoodTable } from 'vue-good-table';
import $ from "jquery";
import moment from "moment";
export default {
name:'historiesStaff',
components:{navbarStaff},
data() {
    return {
      radio_btn: "",
      transProps: {
        // Transition name
        name: "flip-list",
      },
      items: [],
      overtime: [
        { key: "index", label: "ลำดับ" },
        { key: "order_code", label: "ออร์เดอร์", sortable: true },
        { key: "std_code", label: "รหัสผู้จอง", sortable: true },
        { key: "std_code", label: "รหัสผู้จอง" },
        { key: "std_name", label: "ชื่อผู้จอง" },
        { key: "locker_number", label: "ตู้ที่" },
        { key: "locker_passcode", label: "รหัส" },
        { key: "mustbeget_date", label: "กำหนดรับ" },
        { key: "order_status", label: "สถานะ", button: "clear" },
      ],
      fields: [
        { key: "index", label: "ลำดับ" },
        { key: "order_code", label: "ออร์เดอร์", sortable: true },
        { key: "std_code", label: "รหัสผู้จอง", sortable: true },
        { key: "std_code", label: "รหัสผู้จอง" },
        { key: "std_name", label: "ชื่อผู้จอง" },
        { key: "locker_number", label: "ตู้ที่" },
        { key: "locker_passcode", label: "รหัส" },
        { key: "mustbeget_date", label: "กำหนดรับ" },
        { key: "order_status", label: "สถานะ" },
      ],
      fieldsOnlock: [
        { key: "index", label: "ลำดับ" },
        { key: "order_code", label: "ออร์เดอร์", sortable: true },
        { key: "std_code", label: "รหัสผู้จอง" },
        { key: "std_name", label: "ชื่อผู้จอง" },
        { key: "locker_number", label: "ตู้ที่" },
        { key: "locker_passcode", label: "รหัส" },
        { key: "mustbeget_date", label: "กำหนดรับ" },
        { key: "staff_name", label: "ผู้ให้บริการ" },
      ],
      fieldsAll: [
        { key: "index", label: "ลำดับ" },
        { key: "order_code", label: "ออร์เดอร์", sortable: true },
        { key: "std_code", label: "รหัสผู้จอง" },
        { key: "std_code", label: "รหัสผู้จอง" },
        { key: "std_name", label: "ชื่อผู้จอง" },
        { key: "locker_number", label: "ตู้ที่" },
        { key: "locker_passcode", label: "รหัส" },
        { key: "mustbeget_date", label: "กำหนดรับ" },
        { key: "order_status", label: "สถานะ" },
        { key: "staff_name", label: "ผู้ให้บริการ" },
      ],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      code: "",
      ready: [],
      newjobs: [],
      myjobs: [],
      packing: [],
      keyword: "",
      detail: [],
      onlocker: [],
      myorders: [],
      perPageAll: 20,
      currentPageAll: 1,
      perPageLock: 20,
      currentPageLock: 1,
      perPageOrder: 20,
      currentPageOrder: 1,
      perPageOvertime: 20,
      currentPageOvertime: 1,
      yourDateString: "2018-12-24 04:19:23",
      item_overtime: [],
      overtime_more: {},
    };
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      // if (date) {
      //   return moment(String(date)).format("MM/DD/YYYY");
      // }
      return moment(date).add(543, "year").format("LL");
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
    rowsorder() {
      return this.myorders.length;
    },
    rowsolocker() {
      return this.onlocker.length;
    },
    rowsovertime() {
      return this.item_overtime.length;
    },
    searching() {
      return this.keyword
        ? this.dataArray.filter(
            (item) =>
              item.audit_user.includes(this.keyword) ||
              item.lastname.includes(this.keyword) ||
              item.email.includes(this.keyword)
          )
        : this.dataArray;
    },
  },
  methods: {
    onChange() {
      // console.log(this.radio_btn);
    },
    OverShowMore(id) {
      this.$set(this.overtime_more, id, true);
    },
    OverShowLess(id) {
      this.$set(this.overtime_more, id, false);
    },
    get_overtime() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_overtime",
          data,
          {
            headers,
          }
        )
        .then((res) => {
          // console.log("res", res);
          this.item_overtime = res.data.OnLockers;
          // console.log(this.item_overtime);
        });
    },
    set_overtime(order_code, std_code) {
      let ip = localStorage.getItem("IP");
      // console.log(ip);
      let data = {
        token: this.token,
        staff_code: this.code,
        std_code: std_code,
        order_code: order_code,
        public_ip: ip,
      };
      // console.log(data);
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/set_overtime",
          data,
          { headers }
        )
        .then((res) => {
          this.item_overtime = res.data.OnLockers;
          // console.log(res.data.OnLockers);
        });
    },
    toggleDetails(item) {
      // console.log(item);
      this.detail = item.order_detail;
      if (item["_showDetails"]) item["_showDetails"] = false;
      else this.$set(item, "_showDetails", true);
    },
    toggleDetailsLocker(item) {
      // console.log(item, "Locker");
      this.detail = item.order_detail;
      if (item["_showDetailsLocker"]) item["_showDetailsLocker"] = false;
      else this.$set(item, "_showDetailsLocker", true);
    },
    rowDetails() {
      // console.log("recompute");
      return new Date().toString();
    },

    gethistory() {
      let data = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_history", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          this.ready = res.data.dasboard[0].ready;
          this.packing = res.data.dasboard[0].packing;
          this.newjobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
          this.onlocker = res.data.OnLockers;
          // console.log(this.onlocker);
          this.myorders = res.data.MyOrders;
          this.items = res.data.AllOrders;
          this.$isLoading(false);
          // console.log(typeof this.items[0].mustbeget_date);
        });
    },
  },
  mounted() {
    setTimeout(() => {
      $("iframe").remove();
    }, 8000);

    this.get_overtime();
    this.totalRows = this.items.length;
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }
    this.gethistory();
    $(document).ready(function () {
      $("#myInput").on("keyup", function () {
        var value = $(this).val().toLowerCase();
        $("#my-table tr").filter(function () {
          $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
        });
      });
    });
  },
}
</script>


<style lang="scss" scoped>
.historiesStaff {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
.space {
  height: 100px;
}
.space_avatar {
  height: 60px;
}

/*  Avatar BUTTON  */
.circle_content {
  position: relative;
}
.circle_img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.circle_floting {
  position: absolute;
  top: -10px;
  left: -22px;
  font-size: 14px;
}
.circle {
  grid-column: 2/3;
  grid-row: 4/6;
  width: 8rem;
  height: 100%;
  justify-self: center;
  border-radius: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
}
.circle__btn {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 9rem;
  height: 6rem;
  display: flex;
  margin: 0.6rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 3.2rem;
  color: var(--primary);
  z-index: 300;
  background: var(--greyLight-1);
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  cursor: pointer;
  position: relative;
}
.circle__btn.shadow {
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.circle__btn .play {
  position: absolute;
  opacity: 0;
  transition: all 0.2s linear;
}
.circle__btn .play.visibility {
  opacity: 1;
}
.circle__btn .pause {
  position: absolute;
  transition: all 0.2s linear;
}
.circle__btn .pause.visibility {
  opacity: 0;
}
.circle__back-1,
.circle__back-2 {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  filter: blur(1px);
  z-index: 100;
}
.circle__back-1 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  background: linear-gradient(
    to bottom right,
    var(--greyLight-3) 0%,
    var(--white) 100%
  );
  -webkit-animation: waves 4s linear infinite;
  animation: waves 4s linear infinite;
}
.circle__back-1.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}
.circle__back-2 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  -webkit-animation: waves 4s linear 2s infinite;
  animation: waves 4s linear 2s infinite;
}
.circle__back-2.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/*END */
/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 14px;
}

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 19.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6.3rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 6.6rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(12.2rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/

/* Card */
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.card-columns {
  column-count: 1;
}
.card-columns-two {
  column-count: 2;
}
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.text-muted i {
  margin: 0 5px;
}
/* */

/*  SEARCH  */
.search {
  grid-column: 3/4;
  grid-row: 2/3;
  position: relative;
  display: flex;
  align-items: center;
}
.search__input {
  width: 100%;
  height: 3rem;
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: var(--greyDark);
}
.search__input::-moz-placeholder {
  color: var(--greyLight-3);
}
.search__input:-ms-input-placeholder {
  color: var(--greyLight-3);
}
.search__input::placeholder {
  color: var(--greyLight-3);
}
.search__input:focus {
  outline: none;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
}
.search__input:focus + .search__icon {
  color: orangered;
}
.search__icon {
  height: 1.3rem;
  position: absolute;
  font-size: 1.5rem;
  padding: 0 1.5rem;
  display: flex;
  color: var(--greyDark);
  transition: 0.3s ease;
}
</style>
